export default "__VITE_ASSET__C59dFUc3__"